export function trimCurrency(amount: number, currencyPrecision: number) {
    return Math.round(Math.max(0, amount) * 10 ** currencyPrecision);
}

export function trimAmountStep(amount: number, step: number) {
    if (!step || step <= 1) {
        return amount;
    }
    return Math.round(amount / step) * step;
}

export const getCurrencyPrecision = (currencyCode: string | undefined): number => {
    switch (currencyCode?.toLowerCase()) {
        case 'jpy':
        case 'irr':
        case 'krw':
        case 'kmf':
        case 'pyg':
        case 'rwf':
        case 'ugx':
        case 'vuv':
        case 'vnd':
        case 'xaf':
        case 'xof':
        case 'xpf':
            return 0;
        case 'kwd':
        case 'jod':
        case 'bhd':
        case 'iqd':
        case 'lyd':
        case 'omr':
        case 'tnd':
            return 3;
        case 'aed':
        case 'usd':
        case 'sar':
        case 'qar':
        default:
            return 2;
    }
};

export const shouldCommafy = (code: string | null | undefined) => {
    if (!code) {
        return false;
    }

    return ['krw'].includes(code);
};
